import { InputNumber } from "antd";

const columns = (action, handleInputChange) => [
  {
    title: 'No',
    dataIndex: 'rownum',
    width: '2%',
  }, {
    title: 'Nisn',
    dataIndex: 'nisn',
  }, {
    title: 'Nis',
    dataIndex: 'nis',
    render: (a, row) => <>{row.nis ? row.nis : "-"}</>,
  }, {
    title: 'Nama Peserta Didik',
    dataIndex: 'nama',
  }, {
    title: 'Jenis Kelamin',
    dataIndex: 'jenis_kelamin',
  }, {
    titleMobile: <span style={{lineHeight: "40px"}}>Sakit</span>,
    title: action?.presensi_siswa_update ? <>
    Sakit<br />
    <InputNumber
      placeholder="0"
      min={0}
      onChange={(value) => handleInputChange(0, 'sakit', value)}
    />
  </> : "Sakit",
    align: "center",
    dataIndex: 'sakit',
    key: 'sakit',
    render: (i, row) => (
      action?.presensi_siswa_update ? <InputNumber
        min={0}
        defaultValue={row.sakit || 0}
        value={row.sakit}
        onChange={(value) => handleInputChange(row.id, 'sakit', value)}
      /> : (row.sakit || 0)
    ),
  }, {
    titleMobile: <span style={{lineHeight: "40px"}}>Izin</span>,
    title: action?.presensi_siswa_update ? <>
      Izin<br />
      <InputNumber
        placeholder="0"
        min={0}
        onChange={(value) => handleInputChange(0, 'izin', value)}
      />
    </> : "Izin",
    align: "center",
    dataIndex: 'izin',
    key: 'izin',
    render: (_, row) => (
      action?.presensi_siswa_update ? <InputNumber
        min={0}
        defaultValue={row.izin}
        value={row.izin}
        onChange={(value) => handleInputChange(row.key, 'izin', value)}
      /> : (row.izin || 0)
    ),
  }, {
    titleMobile: <span style={{lineHeight: "40px"}}>Alpha</span>,
    title: action?.presensi_siswa_update ? <>
      Alpha<br />
      <InputNumber
        placeholder="0"
        min={0}
        onChange={(value) => handleInputChange(0, 'alpha', value)}
      />
    </> : "Alpha",
    align: "center",
    dataIndex: 'alpha',
    key: 'alpha',
    render: (_, row) => (
      action?.presensi_siswa_update ? <InputNumber
        min={0}
        defaultValue={row.alpha}
        value={row.alpha}
        onChange={(value) => handleInputChange(row.key, 'alpha', value)}
      /> : (row.alpha || 0)
    ),
  },
];

export default columns